import { Component } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'careplan';
  constructor(){
    let url = window.location.href;
    //url = url.split('?')[0];
    let params = window.location.search;
    if(url.includes('/app/')){
      let payload = {
        url: `/app${url.split('/app').pop()}`,
        params
      }
      sessionStorage.setItem('deeplink', JSON.stringify(payload))
    }
  }
}
